import { useState } from 'react';
import PropTypes from 'prop-types';
import { ConnectedInput } from '@eti/form';
import { ValidationProvider, useTranslation, useSnowplowTracking, useProperty } from '@eti/providers';
import { constants, persistInputData } from '@eti/utils';
import { cx } from '@eti/styles';
import { MAX_CHARS, TRAVEL_CPF_NUMBER, TRAVEL_DOCUMENT_NUMBER } from '../../utils/constants';
import { useValidationRuleName, useTravelDocumentHint } from './utils/hooks';
import { rules } from './utils/validators';
import { CPF } from './utils/constants';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  MOUSE_FLOW_CLASS_NAMES
} = constants;
const TravelDocumentNumber = _ref => {
  let {
    className,
    documentCountryCode,
    form,
    id,
    isDocumentTypePassport = true,
    labelRef,
    selectedDocument
  } = _ref;
  const {
    p
  } = useProperty();
  const {
    t
  } = useTranslation();
  const validationRuleName = useValidationRuleName(id, documentCountryCode, isDocumentTypePassport, selectedDocument);
  const {
    isSnowplowTrackingEnabled,
    sendTrackEvent
  } = useSnowplowTracking();
  const hint = useTravelDocumentHint(selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.value, isDocumentTypePassport);
  const [documentNumberHasChanged, setDocumentNumberHasChanged] = useState(false);
  const inputName = (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.value) === CPF ? `${TRAVEL_CPF_NUMBER}-${id}` : `${TRAVEL_DOCUMENT_NUMBER}-${id}`;
  const label = isDocumentTypePassport ? t('TravelerForm.TravelDocumentNumber.Label') : t('TravelerForm.TravelDocumentNumber.Document.Label');
  let placeholder = isDocumentTypePassport ? t('Input.Passport.Placeholder') : t('Input.Document.Placeholder');
  if ((selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.value) === CPF) {
    placeholder = t('Input.CPF.Placeholder');
  }
  const dataTestID = (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.value) === CPF ? `traveler-travel-cpf-number-${id}-input` : `traveler-travel-document-number-${id}-input`;
  const handleOnChange = () => {
    if (isSnowplowTrackingEnabled && !documentNumberHasChanged) {
      sendTrackEvent({
        category: 'Traveler Details',
        action: 'Input',
        label: 'Travel Document Number',
        value: parseInt(id, 10) + 1
      });
      setDocumentNumberHasChanged(true);
    }
  };
  const documentValidationMessages = {
    passportNumberIsRequired: t('Validation.TravelDocumentNumber.Required'),
    travelDocumentNumberMaxChar: t('Validation.TravelDocumentNumberMaxChar.Exceeded'),
    passportNumberIsInvalid: t('Validation.TravelDocumentNumber.Invalid')
  };
  const handleOnBlur = p('IbeClient.TravelerDetails.PersistFormData.Enabled') ? event => {
    persistInputData(form, inputName)(event.target.value);
  } : undefined;
  return /*#__PURE__*/_jsx(ValidationProvider, {
    rules: rules(id, documentValidationMessages),
    children: /*#__PURE__*/_jsx(ConnectedInput, {
      autoCapitalize: "off",
      autoCorrect: "off",
      className: cx(className, MOUSE_FLOW_CLASS_NAMES),
      "data-testid": dataTestID,
      description: hint,
      label: label,
      labelRef: labelRef,
      maxLength: MAX_CHARS,
      name: inputName,
      onBlur: handleOnBlur,
      onChange: handleOnChange,
      placeholder: placeholder,
      shouldMarkInputAsRequired: true,
      spellCheck: "false",
      validationRuleName: validationRuleName
    })
  });
};
TravelDocumentNumber.propTypes = {
  className: PropTypes.string,
  documentCountryCode: PropTypes.string,
  form: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isDocumentTypePassport: PropTypes.bool,
  labelRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]),
  selectedDocument: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string
  })
};
export default TravelDocumentNumber;
//# sourceMappingURL=TravelDocumentNumber.js.map